import React from "react";
import useTrusteeBondForm from "../../../features/bonds/trustee/hooks/useTrusteeBondForm";
import BondWizardPageShell from "./BondWizardPageShell";
import { bondWizardPageConfig } from "./bondWizardPageConfig";

const VermostTrusteeBondRequestForm = () => {
  const form = useTrusteeBondForm();
  return (
    <BondWizardPageShell config={bondWizardPageConfig.trustee} form={form} />
  );
};

export default VermostTrusteeBondRequestForm;
